// extracted by mini-css-extract-plugin
export var description = "hB_c";
export var iconContainer = "hB_f9";
export var label = "hB_bk";
export var navItemContainer = "hB_qq";
export var textContainer = "hB_c4";